'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _helpers = require('./helpers');

exports.default = function (initialState, handlers) {
  return function () {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
    var action = arguments[1];

    var handleAction = function handleAction(actionHandlers) {
      for (var actionType in actionHandlers) {
        var handler = actionHandlers[actionType];

        if (actionType === action.type) return handler(state, action);
        if ((0, _helpers.isOtherType)(actionType)) return handleAction(handler);
      }

      return state;
    };

    return handleAction(handlers);
  };
};